module.exports = __webpack_public_path__ + "img/internet3.838fbc63.png";